import React, { Component } from 'react'
import './addbutton.scss'
import Button from '../Button'
class AddButton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			copy: props.text ? props.text : '',
			onClick: props.onCLick ? props.onClick : this.handleClick
		}
	}

	handleClick = () => {
		console.log('Click detected inside bounds')
	}

	render() {
		let classes = ['vbui--addbutton', this.props.classes, this.props.state].join(' ')
		return (
			<div className={classes} onClick={this.handleClick}>
				<div className="add-btn">
					<Button classes="fill large content-width" showIcon={true} icon="icon-icon-plus"></Button>
					{this.state.copy && <p className="btn-copy">{this.state.copy}</p>}
				</div>
			</div>
		)
	}
}

export default AddButton
